import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainMenuComponent } from './components/main-menu/main-menu.component';
import { NotificationComponent } from './components/notification/notification.component';
import { HttpClientModule } from '@angular/common/http';
import { AppListComponent } from './routes/app-list/app-list.component';
import { AppAddComponent } from './routes/app-add/app-add.component';
import { AppDetailComponent } from './routes/app-detail/app-detail.component';
import { GatewayComponent } from './routes/gateway/gateway.component';
import { FormsModule } from '@angular/forms';
import { MercedesLoaderComponent } from './components/loaders/mercedes-loader/mercedes-loader.component';
import { InfoComponent } from './routes/info/info.component';
import { DialComponent } from './routes/dial/dial.component';
import { LoginComponent } from './routes/login/login.component';
import { OpenidComponent } from './routes/openid/openid.component';
import { PublicGatewayComponent } from './routes/public-gateway/public-gateway.component';
import { PaginationComponent } from './components/pagination/pagination.component';

@NgModule({
  declarations: [
    AppComponent,
    MainMenuComponent,
    LoginComponent,
    OpenidComponent,
    AppListComponent,
    AppAddComponent,
    AppDetailComponent,
    GatewayComponent,
    MercedesLoaderComponent,
    NotificationComponent,
    InfoComponent,
    DialComponent,
    PublicGatewayComponent,
    PaginationComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
